import { render, staticRenderFns } from "./DocumentDeleteConfirmationPopup.vue?vue&type=template&id=008a3785&scoped=true"
import script from "./DocumentDeleteConfirmationPopup.vue?vue&type=script&lang=js"
export * from "./DocumentDeleteConfirmationPopup.vue?vue&type=script&lang=js"
import style0 from "./DocumentDeleteConfirmationPopup.vue?vue&type=style&index=0&id=008a3785&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008a3785",
  null
  
)

export default component.exports